import { Coupon, CouponFormData } from "../types/coupon";
import { get, post } from "./fetch.core";

async function create(data: CouponFormData) {
  if (!data.eligibility.firstTimeRegAfter) {
    delete data.eligibility.firstTimeRegAfter;
  }

  const rst = await post("/admin/coupon/create", data);
}

export async function loadCoupons() {
  const rst = await get<Coupon[]>("/admin/coupon/list");
  return rst.data;
}

async function edit(data: CouponFormData, id: string) {
  if (!data.eligibility.firstTimeRegAfter) {
    delete data.eligibility.firstTimeRegAfter;
  }

  const rst = await post(`/admin/coupon/edit?couponId=${id}`, data);
}

async function getOne(id: string) {
  const rst = await get<Coupon>(`/admin/coupon/get?couponId=${id}`);
  return rst.data;
}

async function deleteCoupon(id: string) {
  const rst = await post("/admin/coupon/delete", { id });
  return rst.data;
}

function isoStringToDays(isoDateString: string) {
  const date = new Date(isoDateString);
  const today = new Date();
  const timeDiff = Math.abs(today.getTime() - date.getTime());
  const dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
  return dayDiff;
}

const obj = {
  loadCoupons,
  create,
  edit,
  getOne,
  deleteCoupon,
  isoStringToDays,
};

export default obj;
